module.exports = __webpack_public_path__ + "static/media/course_2-alt.d69dfd04.mp4";